import React, { useMemo } from "react";
import styled, { keyframes } from "styled-components";
import { Content, Column } from "../GalleryModal/GalleryModal.styles";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonCell = styled.div`
  width: 100%;
  aspect-ratio: ${({ $ratio }) => $ratio};
  border-radius: 4px;
  background: linear-gradient(90deg, #152a47 0px, #203c62 80px, #152a47 160px);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`;

// Uglavnom 3/4, malo varijacija
const RATIOS = ["3/4", "3/4", "3/4", "9/6", "3/4", "9/6", "3/4", "3/4"];

const GalleryModalSkeletonLoader = ({
  numOfColumns = 4,
  rowsPerColumn = 6,
}) => {
  const columns = useMemo(() => {
    return Array.from({ length: numOfColumns }).map((_, colIndex) =>
      Array.from({ length: rowsPerColumn }).map((_, rowIndex) => {
        const seed = colIndex * rowsPerColumn + rowIndex;
        return RATIOS[seed % RATIOS.length];
      }),
    );
  }, [numOfColumns, rowsPerColumn]);

  return (
    <Content>
      {columns.map((ratios, colIndex) => (
        <Column key={colIndex} $numOfColumns={numOfColumns}>
          {ratios.map((ratio, rowIndex) => (
            <SkeletonCell key={rowIndex} $ratio={ratio} />
          ))}
        </Column>
      ))}
    </Content>
  );
};

export default GalleryModalSkeletonLoader;
